import React, { useEffect, useState } from 'react';
import { withConfig } from 'hoc/config.hoc';
import { fetchApplyNowTracking } from 'externals/_services/tracking.service';
import {
  NEGATIVE_MARKS,
  CREDIT_REPAIR_EXPERT,
  CREDIT_REPAIR_PL_PREQUAL,
} from 'partial/OfferManager/module.constants';
import {
  plantMetadataInLocalStorageAndReturnTransferUrl,
  convertProps,
  setPartnerNameAndImageWithId,
} from 'partial/OfferManager/holder/genericOfferLogic';
import {
  CLICK_APPLY,
  SEEN_OFFER,
} from 'externals/_tracking/types/eventTypes.constants';
import { useLogger } from 'hook/error.hook';
import VisibilitySensor from 'react-visibility-sensor';
import useTrackingMetadata from 'externals/_tracking/useTrackingMetadata';
import { getFullAttributes } from 'helpers/tracking.helpers';
import { useVariationForExperiment } from 'externals/_tracking/optimizely/optimizely.hook';
import {
  OCF_ALL_PRODUCTS,
  OCF_WHATS_CHANGE_REPORT_CARD,
} from 'externals/_tracking/optimizely/index';
import { isMobileByOS } from 'externals/_tracking/dom/navigator';
import { wrapService } from 'actions/service_wrapper.actions';
import { useDispatch, useSelector } from 'react-redux';
import { getMrphPageFormFactor } from 'helpers/metadataLogic.helpers';
import { trimPhoneNumber } from 'helpers/phone.helper';
import { useFlag } from 'hook/flag.hook';
import { OFFERS_IMAGE_PROXY } from 'helpers/env';

const a_fetchApplyNowTracking = wrapService(fetchApplyNowTracking, {
  name: 'cr_fetchApplyNowTracking',
});

const CreditRepairOfferHolder = props => {
  const creditRepairOfferHolderFlag = useFlag('credit_repair_offer_holder', {
    defaultConfig: null,
    forceDefaultConfigForDisabledOptimizely: true,
  });

  const dispatch = useDispatch();
  const trackingManager = useTrackingMetadata();
  const { pageNameMeta } = trackingManager;
  let displayNumber = '';
  let creditRepairEndpoint = '';
  let moduleTid = null;
  let uid = '';
  let pagePosition = props.pagePosition;
  const modulePosition = props.modulePosition;
  const config = props.config;

  const creditRepairExpertConfig = config
    ? config.creditRepair.lexingtonLaw.creditRepairExpertLexLawOffer
    : {};
  const paymentHistoryConfig = config
    ? config.creditRepair.lexingtonLaw.paymenHistoryLexLawOffer
    : {};
  const negativeMarksConfig = config
    ? config.creditRepair.lexingtonLaw.negativeMarksLexLawOffer
    : {};
  const offerModulePosition = props.offerModulePosition;
  const logger = useLogger({
    name: 'CreditRepairOfferHolder',
  });
  const [partnerUrl, setPartnerUrl] = useState(null);
  const [isSeenTriggered, setIsSeenTriggered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const ocfLoggedIn = useSelector(state => state.app.ocfLoggedIn);

  const overWriteCreditRepairOfferData =
    creditRepairOfferHolderFlag?.config?.offers_repairs_cta?.offers?.find(
      c => c.productKey === props.offerMetadata?.productKey,
    );

  const buttonLabel =
    overWriteCreditRepairOfferData?.cta ?? 'Check Your Options';

  const queryStringInitialized = props.offerMetadata.creditRepairId
    ? true
    : false;

  useEffect(() => {
    if (props.offerMetadata && props.offerMetadata.linkUrl && !partnerUrl) {
      setPartnerUrl(props.offerMetadata.linkUrl);
    }
  }, [props.offerMetadata, partnerUrl]);

  const negMarksNumber = negativeMarksConfig.number;
  const negMarksTid = negativeMarksConfig.tid;
  const negMarksEndpoint = negativeMarksConfig.creditRepairEndpoint;
  const negMarksUid = negativeMarksConfig.uid;

  const crExpertNumber = creditRepairExpertConfig.number;
  const crExpertTid = creditRepairExpertConfig.tid;
  const crExpertEndpoint = creditRepairExpertConfig.creditRepairEndpoint;
  const crExpertUid = creditRepairExpertConfig.uid;

  const allProductsOcfExp = useVariationForExperiment(OCF_ALL_PRODUCTS);
  const allProductsOcfExpVar1 =
    allProductsOcfExp.loading === false &&
    allProductsOcfExp.variation === 'VAR1';

  const whatsChangeExp = useVariationForExperiment(
    OCF_WHATS_CHANGE_REPORT_CARD,
  );
  const whatsChangeExpVar1 =
    whatsChangeExp.loading === false && whatsChangeExp.variation === 'VAR1';

  let expTid = null;
  if (allProductsOcfExpVar1) {
    expTid = '33842';
  } else if (whatsChangeExpVar1) {
    expTid = '33846';
  }

  // POD3-2905
  const creditRepairRedesignExp = props?.isExp;

  const paymentHistoryNumber = paymentHistoryConfig.number;
  const paymentHistoryTid = expTid ? expTid : paymentHistoryConfig.tid;
  const paymenyHistoryEndpoint = paymentHistoryConfig.creditRepairEndpoint;

  if (props.module === NEGATIVE_MARKS) {
    displayNumber = negMarksNumber;
    moduleTid = negMarksTid;
    pagePosition = 'Negative Marks';
    creditRepairEndpoint = negMarksEndpoint;
    uid = negMarksUid;
  } else if (props.module === CREDIT_REPAIR_EXPERT) {
    displayNumber = crExpertNumber;
    // POD3-2905
    if (creditRepairRedesignExp === 'var1') {
      moduleTid = '34223';
    } else if (creditRepairRedesignExp === 'var2') {
      moduleTid = '34222';
    } else {
      moduleTid = crExpertTid;
    }

    pagePosition = 'Credit Repair Expert';
    creditRepairEndpoint = crExpertEndpoint;
    uid = crExpertUid;
  } else if (props.module === CREDIT_REPAIR_PL_PREQUAL) {
    //TODO: move these values to config.json when normalizing WEBNXT-5672
    if (isMobileByOS()) {
      displayNumber = '888-586-7097';
      moduleTid = '33579';
    } else {
      displayNumber = '888-586-1891';
      moduleTid = '33580';
    }
    creditRepairEndpoint = 'a/affiliates-collection';
    uid = crExpertUid;
  } else {
    displayNumber = paymentHistoryNumber;
    moduleTid = paymentHistoryTid;
    creditRepairEndpoint = paymenyHistoryEndpoint;
    uid = paymentHistoryConfig.uid;
  }

  const callNumber = trimPhoneNumber(displayNumber);
  const finalDisplayNumber = '1-' + displayNumber;

  const defaultEventHandler = (name, attributes = {}) => {
    const fullAttributes = getFullAttributes({
      pagePosition: pagePosition,
      modulePosition: modulePosition,
      offerMetadata: props.offerMetadata,
      position: offerModulePosition,
      extraAttributes: props.extraAttributes,
      attributes: attributes,
    });

    props.eventHandler(name, fullAttributes);
  };

  const convertToFinalUrl = (
    trackingMetadata,
    moduleTid,
    creditRepairEndpoint,
    uid,
  ) => {
    let initUrl = trackingMetadata.partnerUrl;

    initUrl = initUrl.replace(/<tid>/g, moduleTid);
    initUrl = initUrl.replace('<creditRepair>', creditRepairEndpoint);
    initUrl = initUrl.replace('<uid>', uid);
    initUrl = initUrl.replace('sub3=null', 'sub3=web');
    return initUrl;
  };

  const onApplyClick = e => {
    e.preventDefault();
    if (isLoading) return;
    setIsLoading(true);

    let backendAttributes = {
      'Click Type': 'Apply',
      'Page Name': pageNameMeta,
      'Page Form Factor': getMrphPageFormFactor(),
      ...props.extraAttributes,
    };

    const propsForBackend = convertProps(
      getFullAttributes({
        pagePosition: pagePosition,
        modulePosition: modulePosition,
        offerMetadata: props.offerMetadata,
        position: props.position,
        extraAttributes: props.extraAttributes,
        attributes: backendAttributes,
        includeBackendRefCode: props.isOcfPage,
      }),
    );

    const id = setPartnerNameAndImageWithId(
      props.offerMetadata.displayString,
      props.offerMetadata.imageLink,
    );

    let windowReference = window.open();
    dispatch(
      a_fetchApplyNowTracking(
        partnerUrl,
        {
          prefill: true,
          props: propsForBackend,
        },
        queryStringInitialized,
      ),
    )
      .then(trackingMetadata => {
        defaultEventHandler(CLICK_APPLY, {
          'Click Type': 'Apply',
          'Click ID': trackingMetadata.clickId,
        });

        windowReference.location =
          plantMetadataInLocalStorageAndReturnTransferUrl(
            convertToFinalUrl(
              trackingMetadata,
              moduleTid,
              creditRepairEndpoint,
              uid,
            ),
            id,
            false,
            ocfLoggedIn,
          );
        setIsLoading(false);
      })
      .catch(err => {
        logger.showError('A problem happened while Transferring', err.message);
        logger.reportAPIError(err);
        setIsLoading(false);
        windowReference.close();
      });
  };

  const onVisibilityChange = isVisible => {
    if (isVisible === true && !isSeenTriggered) {
      defaultEventHandler(SEEN_OFFER, {});
      setIsSeenTriggered(true);
    }
  };

  const bullets =
    overWriteCreditRepairOfferData?.bullets ?? props.offerMetadata.bullets;

  return (
    <VisibilitySensor onChange={onVisibilityChange}>
      <props.creditRepairTemplate
        {...props}
        offerImageLinkUrlProxy={`${OFFERS_IMAGE_PROXY}${props.offerMetadata?.imageLink}`}
        bullets={bullets}
        buttonLabel={buttonLabel}
        clickApplyImageHandler={onApplyClick}
        clickApplyHandler={onApplyClick}
        callNumber={callNumber}
        displayNumber={finalDisplayNumber}
        seenPixel={
          <VisibilitySensor onChange={onVisibilityChange}>
            <div className="invisible-pixel" />
          </VisibilitySensor>
        }
      />
    </VisibilitySensor>
  );
};

const CreditRepairOfferHolderWrapped = withConfig(CreditRepairOfferHolder);

export default CreditRepairOfferHolderWrapped;
